<template lang="pug">
#NoteItem
  .note-item
    .header
      .creation-date(:style="{ color: note.done ? '#00000029' : '' }") {{ [note.createdAt] | moment('DD [de] MMMM [de] YYYY') }}
      .buttons
        b-button(v-if="!note.done" @click="showEditModal(note)" size="sm", variant="light" style="color:#616161")
          font-awesome-icon(:icon="['far', 'edit']")
        b-button(@click="onDeleteNote(note.id)", size="sm", variant="light" style="color:#616161")
          font-awesome-icon(:icon="['far', 'trash-alt']")
    h4.responsable.text-truncate(:style="{ color: note.done ? '#00000029' : '' }") {{ note.userId ? (note.userId.name +' '+ note.userId.lastName) : '-' }}
    .description(:style="{ color: note.done ? '#00000029' : '' }") {{ note.description }}
    .footer
      .reminder(v-if="note.done") Tarea Realizada
      .reminder(v-else)
        font-awesome-icon(v-if="note.reminder" :icon="['fas', 'stopwatch']")
        div(v-if="note.reminder" style="margin-left: 6px;") {{ [note.reminder] | moment('DD[/]MMM[/]YY HH:mm[hrs]') }}
      b-form-checkbox.check(v-model="data.done" @change="onUpdateNote()"  size="lg" style="float: right;")
  b-modal(v-model="showEdit", :hide-footer="true", title="Editar Nota" no-close-on-backdrop)
    create-edit-form(v-if="showEdit", :hideModal="hideEditModal", :selectedNote="selectedNote", :makeToast="makeToast", :order="order")
</template>

<script>
import { mapActions } from 'vuex'
import CreateEditForm from './CreateEditForm'

export default {
  components: {
    CreateEditForm
  },
  props: ["filterUser","note","order"],
  data () {
    return {
      showEdit: false,
      selectedNote: null,
      data: {
        done: this.note.done,
        reminder:this.note.reminder ? this.note.reminder : null,
        description:this.note.description ? this.note.description : '',
        id:this.note.id,
        userId:this.note.userId ? this.note.userId.id : null
      }
    }
  },
  methods: {
    ...mapActions(['listNote', 'deleteNote', 'updateNote']),
    async onUpdateNote () {
      await this.updateNote(this.data)
      await this.listNote({ userId: this.filterUser, order:this.order })
      this.editMode = false
    },
    async onDeleteNote () {
      const ok = await this.$bvModal.msgBoxConfirm('¿Está seguro de que desea eliminar esta nota?')
      if (ok) {
        const response = await this.deleteNote({ id: this.note.id })
        if (response.status === 200) {
          this.$root.$bvToast.toast('La nota se eliminó correctamente', {
          title: 'Éxito!!',
          variant: 'success'
        })
          this.$emit('done')
          if(this.filterUser) {
            this.listNote({ userId: this.filterUser, order:this.order })
          }else{
            await this.listNote({ userId: null, order:this.order })
          }
          return
        }
        this.$root.$bvToast.toast('No se pudo eliminar', {
          title: 'Error',
          variant: 'danger'
        })
      }
    },
    showEditModal(){
      this.selectedNote = this.note;
      this.showEdit = true;
    },
    async hideEditModal() {
      if(this.filterUser) {
        await this.listNote({ userId: this.filterUser, order:this.order })
      }else{
        await this.listNote({ userId: null, order:this.order })
      }
      this.showEdit = false;
    },
    makeToast(variant=null, body, title) {
      this.$bvToast.toast(
        body,
        {
          title,
          variant,
          solid: true,
          hide: true,
          autoHideDelay: 3000
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.note-item {
  width: 340px;
  height: 220px;
  align-items: center;
  padding: 16px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #8C9195;
  border-radius: 5px;
  opacity: 1;
  margin: 0px 15px 15px 0px;
  font: normal normal Open Sans;
  letter-spacing: 0px;
  button {
    margin-left: 8px;
  }
}
.creation-date {
  text-align: left;
  color: #8C9195;
  font-weight: bold;
}
.responsable {
  text-align: left;
  color: #2B3238;
  margin: 15px 0px;
  font-weight: bold;
}
.buttons {
  float: right;
  margin-top: -24px;
}
.description {
  color: #8C9195;
  margin: 15px 0px;
  height: 77px;
  overflow: auto;
}
.reminder {
  color: var(--primary);
  font-weight: bold;
  display: inline-flex;
  align-items: center;
}
.footer {
  display: flex;
  justify-content: space-between;
  margin-top: -4px;
}
</style>
